import { render, staticRenderFns } from "./option-header.vue?vue&type=template&id=48c034d0&scoped=true&"
import script from "./option-header.vue?vue&type=script&lang=js&"
export * from "./option-header.vue?vue&type=script&lang=js&"
import style0 from "./option-header.vue?vue&type=style&index=0&id=48c034d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c034d0",
  null
  
)

export default component.exports